"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteMenuItemsMutationOptions = exports.deleteMenuItemsMutation = void 0;
const client_1 = require("@apollo/client");
const updateQuery_1 = require("../../../utils/updateQuery");
const menuPlanner_1 = require("../queries/menuPlanner");
exports.deleteMenuItemsMutation = client_1.gql `
  mutation DeleteMenuItems($ids: [String!]!) {
    deleteMenuItems(ids: $ids) {
      ok
    }
  }
`;
exports.deleteMenuItemsMutationOptions = (variables, menuPlannerQueryVariables) => ({
    variables,
    optimisticResponse: {
        __typename: "Mutation",
        deleteMenuItems: { __typename: "OkResponse", ok: true },
    },
    update: !menuPlannerQueryVariables
        ? undefined
        : store => {
            updateQuery_1.updateQuery(store, menuPlanner_1.menuPlannerQuery, x => {
                x.menuPlanner = x.menuPlanner.filter(y => !variables.ids.includes(y.id));
            }, menuPlannerQueryVariables);
        },
});
//# sourceMappingURL=deleteMenuItem.js.map